export default class Header {
  constructor(element) {
    this.element = element;
    this.options = {
      threshold: 0.1,
    };

    this.header = document.querySelector('.header');
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;

    // Menu mobile
    this.menuToggle = this.element.querySelector('.menu-toggle');
    this.menu = this.element.querySelector('.menu');

    this.init();
    this.initNavMobile();
  }

  init() {
    this.setOptions();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  // ==========================================================
  // Menu mobile
  // ==========================================================

  initNavMobile() {
    if (!this.menuToggle || !this.menu) return;

    this.menuToggle.addEventListener('click', this.onToggleNav.bind(this));

    this.menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', this.closeNav.bind(this));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeNav();
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target)) {
        this.closeNav();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024) {
        this.closeNav();
      }
    });
  }

  onToggleNav() {
    const isOpen = this.element.classList.toggle('menu-open');

    this.menuToggle.setAttribute('aria-expanded', String(isOpen));
    this.menuToggle.setAttribute(
      'aria-label',
      isOpen ? 'Fermer le menu' : 'Ouvrir le menu',
    );
  }

  closeNav() {
    if (!this.menuToggle) return;

    this.element.classList.remove('menu-open');

    this.menuToggle.setAttribute('aria-expanded', 'false');
    this.menuToggle.setAttribute('aria-label', 'Ouvrir le menu');
  }

  setOptions() {
    if ('threshold' in this.header.dataset) {
      this.options.threshold = this.header.dataset.threshold;
    }
    if ('alwaysShow' in this.header.dataset) {
      this.options.threshold = 1000;
    }
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setHeaderState();
    this.setDirections();
  }

  setDirections() {
    if (this.scrollPosition >= this.lastScrollPosition) {
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');
    } else {
      this.html.classList.add('is-scrolling-up');
      this.html.classList.remove('is-scrolling-down');
    }
  }

  setHeaderState() {
    if (
      this.scrollPosition >=
      document.scrollingElement.scrollHeight * this.options.threshold
    ) {
      this.html.classList.add('header-is-hidden');
    } else if (this.scrollPosition < this.lastScrollPosition) {
      this.html.classList.remove('header-is-hidden');
    }
  }
}
